module.exports = __webpack_public_path__ + "img/bg.352dae73.svg";